<template>
    <Line v-if="chartData" :data="chartData" :options="chartOptions"  />
    <p v-else>No data available to display the chart</p>
  </template>
  
  
  <script>
  import { Line } from 'vue-chartjs';
  import annotationPlugin from 'chartjs-plugin-annotation';
  import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, Filler } from 'chart.js';  
  ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, Filler, annotationPlugin);
  
  export default {
    name: 'LineChart',
    components: { Line },
    data() {
      return {
        chartData: {},
        chartOptions: {}
    };
    },
  };
  </script>
  